import { ProfileAvatar } from "@modules/profile/common/components/profileAvatar"
import { Badge } from "primereact/badge"
import styled from "styled-components"

type ChatAvatarProps = {
  image?: string
  name?: string
  size?: number
  isOnline?: boolean
}

export const ChatAvatar: React.FC<ChatAvatarProps> = ({ image, name, size = 20, isOnline }) => {
  return (
    <Container>
      <ProfileAvatar
        profile={{ avatar: image ? { path: image, blurHash: "" } : undefined, username: name ?? "A" }}
        size={size}
      />
      {isOnline && (
        <BadgeContainer>
          <Badge severity="success" size="normal" />
        </BadgeContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: relative;
`
const BadgeContainer = styled.div`
  position: absolute;
  top: -3px;
  right: -3px;
  background-color: white;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .p-badge {
    width: 0.6rem;
    min-width: 0.6rem;
    height: 0.6rem;
  }
`
